// @flow

import { startRequest, finishRequest } from "@store/utils";
import { cloneObject } from "@utils/object";

import {
  GetServiceDirectoryCategories,
  GetServiceDirectoryCategoriesSuccess,
  GetServiceDirectoryCategoriesError,
  GetServiceDirectorySubCategories,
  GetServiceDirectorySubCategoriesSuccess,
  GetServiceDirectorySubCategoriesError,
  ResetServiceDirectoryCategories,
} from "@modules/profile/constants/actions";
import type { ServiceDirectoryState } from "./types";

export const initialState: ServiceDirectoryState = {
  requestsInProgress: 0,
  error: null,
  categories: [],
  subCategories: [],
};

const setLoading = (state: ServiceDirectoryState) => () => {
  return {
    ...startRequest(state),
  };
};

const onError = (state: ServiceDirectoryState) => ({ payload }: Object) => {
  return {
    ...finishRequest(state),
    error: payload,
  };
};

const onGetServiceDirectoryCategoriesSuccess = (state: ServiceDirectoryState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    categories: payload,
  };
};

const onGetServiceDirectorySubCategoriesSuccess = (state: ServiceDirectoryState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    error: null,
    subCategories: payload,
  };
};

const onResetServiceDirectoryCategories = (state: ServiceDirectoryState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    categories: [],
    subCategories: [],
  };
};

export default (
  state: ServiceDirectoryState = initialState,
  action: Object,
): ServiceDirectoryState => {
  const act = {
    [GetServiceDirectoryCategories]: setLoading,
    [GetServiceDirectoryCategoriesSuccess]: onGetServiceDirectoryCategoriesSuccess,
    [GetServiceDirectoryCategoriesError]: onError,
    [GetServiceDirectorySubCategories]: setLoading,
    [GetServiceDirectorySubCategoriesSuccess]: onGetServiceDirectorySubCategoriesSuccess,
    [GetServiceDirectorySubCategoriesError]: onError,
    [ResetServiceDirectoryCategories]: onResetServiceDirectoryCategories,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
